module.exports = __webpack_public_path__ + "static/media/feishu_chat.03602917.png";